import { ILoyaltyBonusOperation } from './ILoyaltyBonusOperation';

export type PossibleOperationType = ILoyaltyBonusOperationReasonOption.OperationType | null;

export interface ILoyaltyBonusOperationReasonOption {
  value?: ILoyaltyBonusOperation.Reason | null;
  label?: string | null;
  possibleOperationType?: PossibleOperationType;
}

export namespace ILoyaltyBonusOperationReasonOption {
  export enum OperationType {
    Accrual = 0,
    ChargeOff = 1,
    Both = 2,
  }
}
